<template>
  <div class="bg position-relative" :style="{ backgroundImage: `url(${index % 2 === 0 ? imgUrl[0] : imgUrl[1]})` }">
    <div class="top_space"/>
    <div class="title text-white"> {{ title }}</div>
    <div class="title_space"/>
    <div class="point_area">
    <div v-for="(item,index) in pointList" class="row align-items-baseline">
      <img class="img_point" src="/img/image/home/green_dot.png" loading="lazy" alt>
      <div class="dot_space"/>
      <div class="col point_text">{{item}}</div>
    </div>
    </div>
  </div>

</template>

<script>
import * as GlideItemType from "../../shared/glide_item_type";

export default {
  name: "JoinItem",
  computed: {
    title() {
      return this.item.title;
    },
    pointList() {
      return this.item.pointList;
    },
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imgUrl: [
        "/img/image/home/join_item_1.png",
        "/img/image/home/join_item_2.png",
      ],
    };
  },
}
</script>

<style scoped>
.bg {
  width: 400px;
  height: auto;
  max-width: 400px;
  background-size: cover;
  aspect-ratio: 1;
  background-position: center;
  background-repeat: no-repeat; /* 防止图像重复 */
}

@media (max-width: 500px) {
  .bg {
    width: 360px;
  }
}
@media (max-width: 450px) {
  .bg {
    width: 300px;
  }
}
@media (max-width: 360px) {
  .bg {
    width: 260px;
  }
}

.top_space {
  height: 16px;
}
@media (max-width: 450px) {
  .top_space {
    height: 8px;
  }
}

.title {
  font-family: Noto Sans TC;
  font-size: 30px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: center;
}
@media (max-width: 450px) {
  .title {
    font-size: 22px;
  }
}


.title_space {
  height: 50px;
}
@media (max-width: 450px) {
  .title_space {
    height: 40px;
  }
}



.point_area{
  margin: 0 auto;
  width: 260px;
  text-align: center;
}

@media (max-width: 450px) {
  .point_area {
    width: 200px;
  }
}
@media (max-width: 360px) {
  .point_area {
    width: 180px;
  }
}


.img_point {
  width: 12px;
  height: 12px;
}

@media (max-width: 450px) {
  .img_point {
    width: 8px;
    height: 8px;
  }
}

.dot_space {
  width: 12px;
}

@media (max-width: 450px) {
  .dot_space {
    width: 8px;
  }
}

.point_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  color: #41332B;
}

@media (max-width: 450px) {
  .point_text {
    font-size: 18px;
  }
}


</style>
